module.exports = __webpack_public_path__ + "images/f1530d6c0f1078bb19e55ef3a8ca77dd.png";